/**
 * @generated SignedSource<<9267be11adbc795a98ec267af594e0dc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useBidPrices_nftAuction$data = {
  readonly reservePrice: {
    readonly ether: string | null;
    readonly wei: string | null;
  } | null;
  readonly " $fragmentType": "useBidPrices_nftAuction";
};
export type useBidPrices_nftAuction$key = {
  readonly " $data"?: useBidPrices_nftAuction$data;
  readonly " $fragmentSpreads": FragmentRefs<"useBidPrices_nftAuction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useBidPrices_nftAuction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EtherAmount",
      "kind": "LinkedField",
      "name": "reservePrice",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ether",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "wei",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftAuction",
  "abstractKey": null
};

(node as any).hash = "ca2dba0fe48773f9c193625b1f8f33df";

export default node;
